import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ApiBaseService, VendorsService} from '../../../../../../projects/vendors/src/public-api';
import { ApiEnum } from '../../../../@application/enum/api.enum';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-section-revenue',
    templateUrl: './section-revenue.component.html',
    styleUrl: './section-revenue.component.scss',
    standalone: false
})
export class SectionRevenueComponent implements OnInit, OnDestroy {
  sectionWiseRevenue= [] as any[];
  apiBaseService = inject(ApiBaseService);
  vendorsService = inject(VendorsService);
  orderCloseSubscription!: Subscription;

  ngOnInit(): void {
    this.dataSubscriptions()
    this.getData();
  }

  private dataSubscriptions() {
    this.orderCloseSubscription = this.vendorsService.orderCloseSubject.subscribe({
      next: orderClose => {
        if (orderClose)
          this.getData();
      }
    })
  }

  private getData() {
    this.apiBaseService.GET<any[]>([ApiEnum.RestaurantModule,ApiEnum.Order,ApiEnum.DashBoard,ApiEnum.SectionRevenue])
      .subscribe({
        next: response => {
          this.sectionWiseRevenue = response;

        }
      })
  }

  ngOnDestroy() {
    this.orderCloseSubscription.unsubscribe();
  }

}
